// extracted by mini-css-extract-plugin
module.exports = {"cmd":"Help_cmd__1VrVQ","list":"Help_list__f1dIB"};